import type { ReactNode } from 'react';
import { cn } from '../utils';

export function FooterCopyright({ children, className }: { children: ReactNode; className?: string }) {
  return <span className={cn('text-center font-body text-base text-subtle-foreground leading-[1.4]', className)}>{children}</span>;
}
